/*
 Created by CHT 2020/10/11 11:48
 */
import BaseItem from "../BaseItem"
import {
  FORM_ITEM__ADDRESS,
  ADDRESS_TYPE__DETAIL,
  ADDRESS_TYPE__CITY,
  ADDRESS_TYPE__COUNTY,
  ADDRESS_TYPE__PROVINCE,
  DATA_TYPE__JSON,
  DEFAULT_VALUE__ADDRESS,
  DEFAULT_VALUE__RELATE_DATA,
  PERMISSION__READ,
  PERMISSION__HIDDEN, FORM_ITEM__TABLE
} from "../types"
import {defaultValueInit} from "../utils"
import AreaData from './AreaData.js'

// 递归计算级联选择 options
function areaList(list, code, tier) {
  if (AreaData[code] && tier) {
    Object.keys(AreaData[code]).forEach(key => {
      const opt = {
        value: key,
        label: AreaData[code][key],
        children: null
      }
      opt.children = areaList([], key, tier - 1)

      if (opt.children.length === 0) {
        delete opt.children
      }

      list.push(opt)
    })
  }
  return list
}

class Address extends BaseItem {
  constructor() {
    super()

    this.value = {
      detailAddress: '', // 精确地址
      county: '',				 // 县、区
      city: '',					 // 市
      province: ''			 // 省
    }

    this.detailType = this.detailTypeList[0].value

    this.defaultValue = {
      defaultType: ''
    }
  }

  get title() {
    return this.fieldTitle || Address._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

Address._title = '地址'
Address.type = FORM_ITEM__ADDRESS
Address.use = true
Address.icon = 'iconfont icon-dizhi'

Address.prototype.type = Address.type
Address.prototype.dataType = DATA_TYPE__JSON
Address.prototype.provinceOptions = areaList([], 86, 1)
Address.prototype.cityOptions = areaList([], 86, 2)
Address.prototype.countyOptions = areaList([], 86, 3)
Address.prototype.detailTypeList = [
  {
    value: ADDRESS_TYPE__DETAIL,
    label: '详细地址'
  },
  {
    value: ADDRESS_TYPE__COUNTY,
    label: '区、县'
  },
  {
    value: ADDRESS_TYPE__CITY,
    label: '市'
  },
  {
    value: ADDRESS_TYPE__PROVINCE,
    label: '省'
  }
]
Address.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: '自定义',
    value: defaultValueInit(DEFAULT_VALUE__ADDRESS)
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }
]
Address.prototype.filterOpts = [
  {
    name: '属于',
    method: 'all'
  },
  {
    name: '不属于',
    method: 'nin'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
Address.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || {
    detailAddress: '', // 精确地址
    county: '',				 // 县、区
    city: '',					 // 市
    province: ''			 // 省
  }
}
Address.prototype.getValue = function () {
  return this.value
}
Address.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    detailType: this.detailType,
    defaultValue: this.defaultValue
  }
}
Address.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.detailType) this.detailType = opts.detailType
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__ADDRESS) {
      this.value = this.defaultValue.defaultAddress
    }
  }
}
Address.prototype.valueToString = function (value) {
  value = value || this.value
  return [value.province, value.city, value.county, value.detailAddress].join('')
}
export default Address
